<template>
	<div class="field" :style="field.style" v-if="condition">
		<label class="label">
			{{local_value.label}}
			{{local_value.required ? ' *' : ''}}
			<a href="" @click.prevent="$emit('reset', local_value)" v-if="field.updated"><i class="fa-solid fa-clock-rotate-left"></i></a>
		</label>
		<div class="control"
			:class="[
				local_value.left_icon ? 'has-icons-left' : '',
				local_value.right_icon ? 'has-icons-right' : ''
			]">
			<input class="input is-small" :class="[field.updated ? 'is-warning' : '', (local_value.readonly || local_value.disabled) ? 'is-static' : '']" 
				type="text" @input="updateField" @blur="checkUnique" @keydown="preventEditIfLocked" @paste="preventEditIfLocked" @cut="preventEditIfLocked"
				v-model="local_value.value" :name="local_value.name" :readonly="!!(local_value.readonly || local_value.disabled)" :disabled="!!(local_value.readonly || local_value.disabled)"
				:placeholder="local_value.placeholder || ''"
				:style="local_value.uppercase ? 'text-transform: uppercase' : ''" />
			<span class="icon is-small is-left" 
					v-if="local_value.left_icon">
				<i :class="local_value.left_icon"></i>
			</span>
			<span class="icon is-small is-right" 
					v-if="local_value.right_icon">
				<i :class="local_value.right_icon"></i>
			</span>
		</div>
		<p class="help is-danger" v-if="local_value.unique !== undefined">
			<span v-if="local_value.exists == 1">
				{{local_value.label}} vendosur eshte i zene!
			</span>
		</p>
		<p class="help is-danger" v-if="false && local_value.required && (!local_value.value || local_value == '')">
			{{ local_value.required_text ? local_value.required_text : 'E detyrueshme' }}
		</p> 
	</div>
</template>

<script>
import Api from '@/services/Api'
	export default{
		props: [
			'field', 'fields'
		], 
		data() {
			return {
				local_value: null
			};
		},
		methods: {
			preventEditIfLocked(e) {
				if (this.local_value.readonly || this.local_value.disabled) e.preventDefault();
			},
			async updateField(){
				if (this.local_value.readonly || this.local_value.disabled) return;
				this.applyUppercase();
				this.$emit('syncField', this.local_value);
			},
			applyUppercase() {
				if (this.local_value.uppercase && typeof this.local_value.value === 'string') {
					const upper = this.local_value.value.toUpperCase();
					if (this.local_value.value !== upper) {
						this.local_value.value = upper;
						return true;
					}
				}
				return false;
			}, 
      async checkUnique(){
        if(this.local_value.unique !== undefined) {
          const raw = this.local_value.value;
          const value = raw == null ? "" : String(raw).trim();
          // Empty optional fields (e.g. barcode) should not be treated as duplicates
          if (value === "") {
            this.local_value = {
              ...this.local_value,
              exists: 0
            }
            this.$emit('syncField', this.local_value)
            return
          }
          await Api(true).post("unique/" + this.local_value.unique.model, {
            ...this.local_value.unique,
            value,
          }).then(resp => {
            this.local_value = {
              ...this.local_value,
              exists: resp.data.exists
            }
            this.$emit('syncField', this.local_value)
          })
        }
      }
		},	
		computed: {
			condition(){
				var is_visible = true
				if(this.local_value.vif){
				if(this.fields)
					this.fields.map(f => {
						if(f.length) {
							f.map(ff => {
								this.local_value.vif.map(c => {
									if(ff.name == c.field){
										if(c.value_not !== undefined) 
											is_visible = ff.value != c.value_not
                    else if(c.value !== undefined)
                      is_visible = ff.value == c.value
									}
								})
							})
						}
						else {
								this.local_value.vif.map(c => {
									if(f.name == c.field) {
										if(c.value_not !== undefined) {
											is_visible = f.value != c.value_not
										}
										if(c.value !== undefined) {
											is_visible = f.value == c.value
										}

									}
								})
						}
					})
				}
				return is_visible
			},
		},
		watch: {
			'field'(){
				this.local_value = {...this.field}
				if (this.applyUppercase()) {
					this.$emit('syncField', this.local_value);
				}
			},

		},
		created(){
			this.local_value = {...this.field}
			if (this.applyUppercase()) {
				this.$emit('syncField', this.local_value);
			}
		}
	}
</script>

<style scoped>
.label {
    margin-bottom: 0!important;
		color: grey;
}
</style>

